import { checkIsMobile } from 'src/app/util';
import * as i0 from "@angular/core";
import * as i1 from "../../member/service/member-proxy.service";
/** GA log 服務 */
export class GALoggerService {
    constructor(memberProxyService) {
        this.memberProxyService = memberProxyService;
    }
    log(data) {
        if (this.memberProxyService.hasLoginSystem && this.memberProxyService.memberInfo) {
            data['client_id'] = this.memberProxyService.memberInfo.memberId;
        }
        data['site_domain'] = checkIsMobile() ? 'APP' : 'PC';
        window['dataLayer'].push(data);
    }
}
GALoggerService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GALoggerService_Factory() { return new GALoggerService(i0.ɵɵinject(i1.MemberProxyService)); }, token: GALoggerService, providedIn: "root" });
